export default {
    name: 'ឈ្មោះ',
    tel: 'ទូរស័ព្ទ',
    save: 'រក្សាទុក',
    confirm: 'បញ្ជាក់',
    cancel: 'បោះបង់',
    delete: 'លុប',
    complete: 'បញ្ចប់',
    loading: 'កំពុងផ្ទុក...',
    telEmpty: 'សូមបំពេញលេខទូរស័ព្ទ',
    nameEmpty: 'សូមបំពេញឈ្មោះ',
    nameInvalid: 'ឈ្មោះមិនត្រឹមត្រូវ',
    confirmDelete: 'តើអ្នកប្រាកដថាចង់លុប?',
    telInvalid: 'លេខទូរស័ព្ទមិនត្រឹមត្រូវ',
    vanCalendar: {
        end: 'បញ្ចប់',
        start: 'ចាប់ផ្តើម',
        title: 'ប្រតិទិន',
        startEnd: 'ចាប់ផ្តើម/បញ្ចប់',
        weekdays: ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `ជ្រើសរើសមិនលើសពី ${maxRange} ថ្ងៃ`,
    },
    vanCascader: {
        select: 'ជ្រើសរើស',
    },
    vanContactCard: {
        addText: 'បន្ថែមព័ត៌មានទំនាក់ទំនង',
    },
    vanContactList: {
        addText: 'បន្ថែមទំនាក់ទំនងថ្មី',
    },
    vanPagination: {
        prev: 'មុន',
        next: 'បន្ទាប់',
    },
    vanPullRefresh: {
        pulling: 'ទាញដើម្បីធ្វើឱ្យស្រស់...',
        loosing: 'បញ្ចេញដើម្បីធ្វើឱ្យស្រស់...',
    },
    vanSubmitBar: {
        label: 'សរុប៖',
    },
    vanCoupon: {
        unlimited: 'គ្មានដែនកំណត់',
        discount: (discount) => `បញ្ចុះតំលៃ ${discount * 10}%`,
        condition: (condition) => `យ៉ាងហោចណាស់ ${condition}`,
    },
    vanCouponCell: {
        title: 'ប័ណ្ណវិក្ក័យបត្រ',
        tips: 'គ្មានប័ណ្ណវិក្ក័យបត្រ',
        count: (count) => `អ្នកមានប័ណ្ណវិក្ក័យបត្រ ${count} សន្លឹក`,
    },
    vanCouponList: {
        empty: 'គ្មានប័ណ្ណវិក្ក័យបត្រ',
        exchange: 'ប្តូរ',
        close: 'បិទ',
        enable: 'អាចប្រើបាន',
        disabled: 'មិនអាចប្រើបាន',
        placeholder: 'កូដប័ណ្ណវិក្ក័យបត្រ',
    },
    vanAddressEdit: {
        area: 'តំបន់',
        postal: 'ប្រៃសណីយ៍',
        areaEmpty: 'សូមជ្រើសរើសតំបន់ទទួល',
        addressEmpty: 'អាសយដ្ឋានមិនអាចទទេ',
        postalEmpty: 'លេខកូដប្រៃសណីយ៍មិនត្រឹមត្រូវ',
        defaultAddress: 'កំណត់ជាអាសយដ្ឋានលំនាំដើម',
        telPlaceholder: 'ទូរស័ព្ទ',
        namePlaceholder: 'ឈ្មោះ',
        areaPlaceholder: 'តំបន់',
    },
    vanAddressEditDetail: {
        label: 'អាសយដ្ឋាន',
        placeholder: 'អាសយដ្ឋាន',
    },
    vanAddressList: {
        add: 'បន្ថែមអាសយដ្ឋានថ្មី',
    },
};